
import * as toastr from 'toastr';
import {Subject} from "rxjs";
import {toJS} from "mobx";
import {BasicDialog} from "PageBuilder/utils/Dialogs/BasicDialog";
import {InsertionTarget, PaperSize} from "PageBuilder/dto/Options";
import {AsyncAjax} from "PageBuilder/utils/JQueryAsync";
import {PDFDocument} from "PageBuilder/pagebuilder/PDFDocument";
import {PDFControlBase} from "InternalShared/PageBuilder/Controls/Core/PDFControlBase";



declare let rednaoPDFInvoiceParams:any;
declare let require:any;
declare let library_pageBuilderReact:any;
export class PageService{
    public ItemInserted=new Subject<ItemInsertedArgs>();
    public ItemDeleted=new Subject<ItemDeletedArgs>();
    public page:PDFDocument;
    private settingDialogs:BasicDialog;
    public previewType:previewType='fake';
    public orderNumberToPreview:number;
    public tagDialog:BasicDialog;
    public static AvailablePaperSizes:PaperSize[]=[{type:"A2",width:1587,height:2245},{type:"A3",width:1123,height:1587},{type:"A4",width:794,height:1123},
        {type:"A5",width:559,height:794},{type:"A6",width:397,height:559},{type:"A7",width:280,height:397},
        {type:"letter",width:816,height:1056},{type:"legal",width:816,height:1344}];


    public async Save(){
        let options:any=Object.assign({},this.page.GetPageOptionsToSave());
        options.containerOptions=JSON.stringify(options.containerOptions);

        if(options.conditions!=''&&options.conditions.conditionList.length==0)
            options.conditions='';
        else
            options.conditions=JSON.stringify(options.conditions);
        options.extensions=JSON.stringify(options.extensions);
        options.attachTo=JSON.stringify(options.attachTo);
        options.pages=JSON.stringify(options.pages);

        return new Promise(async (resolve)=>{
            let result=await AsyncAjax.Post<any>('rednao_wcpdfinv_save',options);
            this.page.PageOptions.Id=result.row_id;
            toastr.success('Template saved successfully');
            resolve();
        })


    }

    private static _instance:PageService;
    public static Instance(){
        if((window as any).RNPageService==null)
            (window as any).RNPageService=new PageService();
        return (window as any).RNPageService;
    }

    public ExecutePreview(){
        let previewType:previewType="fake";
        let orderNumberToPreview:number=0;
        if(this.previewType=="orderNumber"&&this.orderNumberToPreview!=null)
        {
            previewType="orderNumber";
            orderNumberToPreview=this.orderNumberToPreview;
        }

        let options=this.page.GetPageOptionsToSave();
        let $form=jQuery(`<form style="display: none" enctype="multipart/form-data" method="post" target="_blank" action="${(window as any).ajaxurl}">
                                <input name="action" type="hidden" value="${rednaoVar._prefix}_execute_preview"/>
                                <input name="data" type="hidden"  value="" class="json" />
                                <input name="_nonce" type="hidden"  value="${rednaoVar._nonce}" />
                                <button></button>
                           </form>                           
                        `);


        jQuery('body').append($form);
        $form.find('.json').val(JSON.stringify({PageOptions:options}));
        $form.submit();
    }

    private ShowTagPopUp() {
        this.tagDialog=new BasicDialog()
            .SetTitle("<i class=\"fa fa-tag\" aria-hidden=\"true\"></i> Select a tag")
            .SetZIndex(1051);

        let $content=jQuery(
            `<ul class="pdfTagList">
                <li data-value="{OrderNumber}">Order Number</li>
                <li data-value="{InvoiceNumber}">Invoice Number</li>
                <li data-value="{CustomerName}">Customer Name</li>                
                <li data-value="{OrderDate}">Order Date</li>
            </ul>`);
        $content.find('li').click((e)=>{
           this.TagSelected(jQuery(e.currentTarget).data('value'));
        });
        this.tagDialog.HideAcceptButton();
        this.tagDialog.SetContent($content);
        this.tagDialog.Show();
    }

    private TagSelected(val: string | number | string[] | undefined) {
        if(rednaoPDFInvoiceParams.IsPr!='1')
        {
            alert('Sorry dynamic tags are only available in the full version');
            return;
        }

        jQuery(".pdfFileName").val(jQuery(".pdfFileName").val().toString()+val);
        if(this.tagDialog!=null) {
            this.tagDialog.Hide();
            this.tagDialog = null;
        }



    }
}


export interface ItemInsertedArgs{
    type:any;
    targetId:InsertionTarget;
    x:number;
    y:number;
    additionalOptions?:any;
}

export type previewType='fake'|'orderNumber';

export interface ItemDeletedArgs{
    target:PDFControlBase;
}